<template>
  <v-sheet
    height="100%"
    class="overflow-hidden"
    style="position: relative; margin-top:0px; border-radius:0; "
  >
    <v-row align="center" class="px-12">
      <!-- <v-col style="flex-grow: 0;">
        <v-icon style="float:left;" right @click="changePage">mdi-arrow-left</v-icon>
      </v-col> -->
      <v-col style="    max-width: fit-content">
        <h4
          style="margin-left: 0px;font-size:28px; color:#777; font-weight:300; text-align:left; max-width: fit-content"
        >Espacios</h4>
      </v-col>
      <v-col offset-xs="3" offset-sm="7" offset-md="8">
        <v-btn
        @click="addQueue"
        color="#679940"
        dark
        rounded
        depressed
        small
        min-width="100"
      >Añadir</v-btn>

          <v-dialog width="500"  v-model="deleteDialog" v-if="selected.length > 0">
            <template v-slot:activator="{ on }">
              <v-btn
              
                v-on="on"
                icon
                color="admiraFontGray"
                class="py-0 my-0"
                style="margin-left:-165px;"
              > <v-icon style="cursor: pointer; font-size:25px">mdi-delete</v-icon>
              </v-btn>
            </template>

            <v-card class="pl-5 pr-5">
              <v-card-title style="color: #679940; padding-left:12px;">Eliminar soporte</v-card-title>
              <v-col justify-center cols="12" class="mt-5 pb-5" style="margin-top:-30px">
                <p>¿Estás seguro que quieres eliminar este elemento?<br>Esta acción no se puede deshacer</p>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-col cols="6">
                    <v-btn
                      style="border-color: #fff;"
                      @click="deleteDialog = false"
                      rounded
                      depressed
                      outlined
                      small
                      width="100"
                    >Cancelar</v-btn>
                  </v-col>

                  <v-col cols="6">
                    <v-btn
                      @click="deleteMulti(selected)"
                      style="background: #679940;"
                      dark
                      rounded
                      depressed
                      outlined
                      small
                      width="100"
                    >Aceptar</v-btn>
                  </v-col>
                </v-card-actions>
              </v-col>
            </v-card>
          </v-dialog>

</v-col>
    </v-row>

    <v-divider  />

    <router-view></router-view>

    <div class="ml-0 mr-0" style="width:100%">
      <div>
        <v-row class="align-center justify-center px-0">
          <v-col
            cols="12"
            class="justify-center align-center px-12 py-6"
            style="min-height: 84vh;"
          >
             <!-- <div v-if="skeleton" class="px-5">
              <v-skeleton-loader class="mx-auto" max-width type="table-thead"></v-skeleton-loader>

              <v-skeleton-loader class="mx-auto" max-width type="table-row-divider@6" height="calc(100vh - 277px)"></v-skeleton-loader> -->

              <!-- <v-skeleton-loader class="mx-auto" max-width type="table-tfoot"></v-skeleton-loader>
            </div>  -->

                        <!-- @click:row="editQueue" -->

            <v-data-table
              @click:row="editQueue"
              v-model="selected"
              show-select
              :headers="headers"
              :items="allSpaces"
              :search="search"
              item-key="idSpace"
              class="elevation-0"
              style="color: #777; cursor:pointer; height: "
              sortBy="idSpace"
              update: sort-desc
              mobile-breakpoint="0"
            >
            
              <!-- <template v-slot:item.icon="{ item }">
                <v-icon v-if="item.type == 1" color="#679940">mdi-human-male-male</v-icon>
                <v-icon v-if="item.type == 2" color="#679940">mdi-ticket-outline</v-icon>
                <v-icon v-if="item.type == 3" color="#679940">mdi-ticket-confirmation</v-icon>
              </template> -->

              <!-- <template v-slot:item.type="{ item }">
                <p style="margin-bottom: -6px;" v-if="item.type == 1" >Fila</p>
                <p style="margin-bottom: -6px;" v-if="item.type == 2" >Tiquets</p>
                <p style="margin-bottom: -6px;" v-if="item.type == 3" >Multipuesto</p>
              </template> -->

              <!-- <template v-slot:item.Actions="{ item }">

                <v-menu offset-y  transition="slide-y-transition" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                    >
                      <v-icon dark>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item @click="editQueueRightMenu(item)">
                      <v-list-item-title style="font-size:12px; color:#9e9e9e"><v-icon style="font-size: 15px; margin-right: 5px;">mdi-pencil</v-icon>Editar</v-list-item-title>
                    </v-list-item>
                    <v-list-item >
                        <v-dialog width="500"  v-model="deleteDialog">
                          <template v-slot:activator="{ on }">
                            <v-list-item-title v-on="on" style="cursor:pointer; font-size:12px; color:#9e9e9e"><v-icon style="font-size: 15px; margin-right: 5px;">mdi-delete</v-icon>Eliminar</v-list-item-title>

            </template>
              <v-card class="pl-5 pr-5">
                <v-card-title style="color: #679940; padding-left:12px;">Eliminar soporte</v-card-title>
                <v-col justify-center cols="12" class="mt-5 pb-5" style="margin-top:-30px">
                  <p>¿Estás seguro que quieres eliminar este elemento?<br>Esta acción no se puede deshacer</p>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-col cols="6">
                      <v-btn
                        style="border-color: #fff;"
                        @click="deleteDialog = false"
                        rounded
                        depressed
                        outlined
                        small
                        width="100"
                      >Cancelar</v-btn>
                    </v-col>

                    <v-col cols="6">
                      <v-btn
                        @click="deleteQueueRightMenu(item)"
                        style="background: #679940;"
                        dark
                        rounded
                        depressed
                        outlined
                        small
                        width="100"
                      >Aceptar</v-btn>
                    </v-col>
                  </v-card-actions>
                </v-col>
              </v-card>
            </v-dialog> 
                    </v-list-item>
                  </v-list>

                </v-menu>

              </template> -->
            </v-data-table> 

            <v-navigation-drawer
            :disable-route-watcher="true"
            :value="showRightMenu"
            absolute
            :clipped="$vuetify.breakpoint.smAndUp"
            width="419"
            style="height: calc(100vh - 50px);z-index:100"
            class="elevation-4"
            right
            stateless
            >
              <RightMenuAddNewQueue v-if="RightMenuAddNewQueue" />
              <RightMenuEditQueue v-if="RightMenuEditQueue" />
            </v-navigation-drawer>

          </v-col>
        </v-row>
      </div>
    </div>
  </v-sheet>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import router from "vue-router";
import RightMenuAddNewQueue from "@/components/RightMenuAddNewQueue.vue";
import RightMenuEditQueue from "@/components/RightMenuEditQueue.vue";


export default {
  name: "Queues",
  components: {
    RightMenuAddNewQueue,
    RightMenuEditQueue,
    deleteDialog: false
  },
  data() {
    return {
      deleteDialog: false,
      search: "",
      skeleton: true,
      selected: [],
      arrProposalData: [],     
    };
  },
  computed: {
        ...mapState("app", ["actualProject"]),

    ...mapState("queues", ["allQueues","RightMenuAddNewQueue","showRightMenu","allSpaces","RightMenuEditQueue"]),

    headers() {
      return [
        { text: "Nombre", value: "name", align: "start", },
      ];
    },

  },
  methods: {
    ...mapMutations("queues", ["setActualSpaceMutation","openRightMenuMutation","closeRightMenuMutation"]),
    ...mapActions("queues", ["getAllQueues","getAllSpaces","getAllResouces","editQueueStore","showRightMenuProposalStore","hideRightMenuProposalStore","rightMenuTrueNewDeviceTableStore","rightMenuTrueNewDeviceTableStore2","deleteMultipleQueues","deleteOneQueueStore"]),
    goToCampaignAs(role) {
      this.viewAsClient = true;
    },
    async editQueue(campaign) {      
      await this.setActualSpaceMutation(campaign);
      this.$router.push({
        name: "ResumeSpaceMobile",
        params: { idQueue: campaign.idSpace },
      });
      // this.closeRightMenuMutation();
    },
    addQueue() {
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore();
      let idProject = this.actualProject.id;
      this.getAllQueues(idProject);
      this.getAllSpaces(idProject);
      this.getAllResouces(idProject);
    },
    editQueueRightMenu(data){
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore2(data);
    },
    deleteQueueRightMenu(data){
      this.deleteOneQueueStore(data);  
      this.closeRightMenuMutation();  
      let idProject = this.actualProject.id;
      this.getAllQueues(idProject);
      this.getAllSpaces(idProject);
      this.getAllResouces(idProject);
    },
    deleteMulti(data){
      let idsQueues = [];
      data.forEach(element => {
        idsQueues.push(element.idQueue) 
      });
      this.deleteMultipleQueues(idsQueues);
      let idProject = this.actualProject.id;
      this.getAllQueues(idProject);
      this.getAllSpaces(idProject);
      this.getAllResouces(idProject);
      this.deleteDialog = false;
      this.selected = [];
    },
    changePage() {
        this.$router.push({
            name: "ResumeSpaceMobile",
        });
        this.closeRightMenuMutation();
    },
  },

  async created() {    
     let idProject = this.actualProject.id;
     await this.getAllSpaces(idProject);  
     await  this.getAllResouces(idProject);   
     await this.getAllQueues(idProject);
  },
  destroyed() {},
};
</script>

<style scoped>
a {
  text-decoration: none;
}
>>> .v-data-table__wrapper {
  height: calc(100vh - 207px);
  overflow: auto;
}
>>> th {
vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/ListSpacesMobile.vue